import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const ArticleHeroWrapper = styled.div`
  position: relative;
  grid-column: 1/ -1;
`;

export const Hero = styled.img`
  margin-bottom: 32px;
  width: 100%;
  min-width: 100%;
  aspect-ratio: 16/9;
  object-position: top;
  object-fit: cover;

  ${mediaDesktop(css`
    margin-bottom: 72px;
  `)}
`;

export const WordsByWrapper = styled.div`
  grid-column: 2/ -2;
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  margin-left: 16px;

  ${({ theme: { locale } }) => setTypography('smallBody', locale)}

  ${mediaDesktop(css`
    position: absolute;
    bottom: -32px;
    margin-left: 124px;
    transform: translateY(100%);
    grid-column: 2/ 4;
  `)}
`;

export const DataRow = styled.div``;

export const Label = styled.span`
  color: ${colors.dustyGray};
`;
export const Data = styled.span``;
